import api from '../api';

import { ParamsBodyChangeBillingPaymentDueDate } from 'utils/typeServices';

export const PostChangeBillingPaymentDueDate = async ({ body }: { body: ParamsBodyChangeBillingPaymentDueDate }) => {
    const bodyJson = JSON.stringify(body);
    const token = localStorage.getItem('token');

    try {
        const { data } = await api.post<{ Data: any }>('v1/Pagamento/ChangeBillingPaymentDueDate', bodyJson, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        return { data: data.Data };
    } catch (error: any) {
        if (error?.response?.data?.ErrorCode === "excecao_prazo_nova_alteracao_cobranca") {
            return { data: false };
        }
        return { data: null };
    }
}
